import commonFn from "@/commons/commonFunction";
import messageBox from "@/commons/messageBox";
import MSJson from "@/commons/json";
import { MSEnum } from "@/commons/enumeration";
import popupUtil from "@/commons/popupUtil";
import VueToast from "vue-toast-notification";
// import Viewer from "v-viewer";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

function looseClone(obj) {
  return MSJson.deserialize(MSJson.serialize(obj));
}

export function registerPlugins(app) {
  app.config.globalProperties.$ms = app.config.globalProperties.$ms
    ? app.config.globalProperties.$ms
    : {};
  app.config.globalProperties.$ms.commonFn = commonFn;
  app.config.globalProperties.$ms.msgBox = messageBox;
  app.config.globalProperties.$ms.msJson = MSJson;
  app.config.globalProperties.$ms.enum = looseClone(MSEnum);
  app.config.globalProperties.$popupUtil = popupUtil;

  // app.use(Viewer);
  // app.use(FloatingVue, {
  //   themes: {
  //     tooltip: {
  //       $defaults: {
  //         placement: 'top',
  //         delay: { show: 500, hide: 0 },
  //       },
  //     },
  //   },
  // });
  app.use(VueToast, {
    position: "top",
    duration: 3000,
  });

  //DNThang - 13.04.2020: Thực hiện nhúng vào toàn bộ các element hàm lấy ra VueInstance tránh dùng __Vue__ không chuẩn tắc
  app.mixin({
    mounted() {
      const me = this;
      if (me.$el && !me.$el.getVueInstance) {
        me.$el.getVueInstance = function () {
          return me;
        };
      }
    },
  });
}
